import styled from 'styled-components';

export const Detail = styled.div<{ showContent: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};

  max-height: ${({ showContent }) => (showContent ? 'max-content' : '11rem')};
  overflow-y: hidden;

  margin-top: 0.5rem;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const DetailContainer = styled.div<{ hidden?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  ${({ hidden }) => hidden && `display: none;`}
`;

export const DetailContainerTitle = styled.span<{ normal?: boolean }>`
  font-family: ${({ theme, normal }) =>
    normal ? theme.fonts.workSans : theme.fonts.openSans};
  font-weight: ${({ normal }) => (normal ? 400 : 600)};
  font-size: ${({ normal }) => (normal ? '1rem' : '1.5rem')};
  line-height: ${({ normal }) => (normal ? '1.5rem' : ' 2rem')};
  color: ${({ theme, normal }) =>
    normal ? theme.colors.grayDark4 : theme.colors.grayDark3};
  margin-bottom: ${({ normal }) => (normal ? 0 : ' 0.5rem')};
`;

export const DetailContentRow = styled.div<{ cols?: number }>`
  display: grid;
  grid-template-columns: ${({ cols }) => (cols ? `repeat(${cols}, 1fr)` : 1)};
  gap: 1.5rem;
`;

export const DetailCardContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 10.75rem;
`;

export const DetailCardHeader = styled.div`
  display: flex;
  gap: 10px;
`;

export const DetailCardText = styled.span<{
  bold?: boolean;
}>`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-weight: ${({ bold }) => (bold ? '600' : '400')};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
